var map = {
	"./PMK.png": 2238,
	"./be-a-sponsor.png": 956,
	"./celcoin.png": 2239,
	"./cepeda.png": 2240,
	"./crdc.png": 2241,
	"./madrona.png": 2242,
	"./master.png": 2243,
	"./nuclea.png": 2244,
	"./oslo.png": 2245,
	"./ouro.png": 2246,
	"./singulare.png": 2247,
	"./tozzini.png": 2248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2237;